var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIco2 = function SvgIco2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50.455 67.57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ico2_svg__a",
    x1: 0.805,
    x2: 0.108,
    y1: 0.982,
    y2: 0.125,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ico2_svg__a",
    id: "ico2_svg__b",
    x1: 0.5,
    x2: 0.462,
    y1: 0.976,
    y2: -0.051
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18890"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7 56.389A22.889 22.889 0 0 1 79.866 67.9a22.405 22.405 0 0 1-6.675-1.016 22.855 22.855 0 0 1-3.072-1.205l-2.232 3.888-3.228-1.867 2.234-3.9a21.635 21.635 0 0 1-1.983-1.542q-.3-.259-.594-.532a22.386 22.386 0 0 1-2-2.129 22.914 22.914 0 0 1-4.431-8.52c-.025-.08-.045-.162-.067-.242a23.613 23.613 0 0 1-.592-2.975 22.9 22.9 0 0 1 .8-9.684 23.237 23.237 0 0 1 1.448-3.624q.3-.594.63-1.176a22.9 22.9 0 0 1 39.6 23.01zm-.865-16.611A19.61 19.61 0 1 0 70.1 61.963a19.533 19.533 0 0 0 26.774-7.214 19.708 19.708 0 0 0 1.958-14.971zM67.67 73.232 61.582 69.7l-1.077-.626-7.552 13.161A4.842 4.842 0 0 0 54.7 88.8a4.721 4.721 0 0 0 2.383.645 4.781 4.781 0 0 0 4.149-2.406l7.552-13.162-1.108-.643z",
    style: {
      fill: "#272f4d"
    },
    transform: "translate(-52.315 -21.878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1 37.557a1.636 1.636 0 0 0-1.628 1.643v10.165a1.631 1.631 0 1 0 3.261 0V39.2a1.636 1.636 0 0 0-1.633-1.643m6.523-10.085A1.636 1.636 0 0 0 70 29.113v20.253a1.631 1.631 0 1 0 3.261 0V29.113a1.636 1.636 0 0 0-1.631-1.641zm6.523 12.861a1.636 1.636 0 0 0-1.631 1.641v7.391a1.631 1.631 0 1 0 3.261 0v-7.39a1.636 1.636 0 0 0-1.627-1.642zm6.523-9.317a1.636 1.636 0 0 0-1.631 1.641v16.708a1.631 1.631 0 1 0 3.261 0V32.657a1.636 1.636 0 0 0-1.631-1.641z",
    "data-name": "data",
    style: {
      fill: "url(#ico2_svg__a)"
    },
    transform: "translate(-47.302 -17.222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67 73.232 61.582 69.7l-1.077-.626-7.552 13.161A4.842 4.842 0 0 0 54.7 88.8a4.721 4.721 0 0 0 2.383.645 4.781 4.781 0 0 0 4.149-2.406l7.552-13.162-1.108-.643z",
    "data-name": "data",
    style: {
      fill: "url(#ico2_svg__b)"
    },
    transform: "translate(-52.315 -21.878)"
  })));
};
export default SvgIco2;